export default function release(Dispatcher, Store) {
  switch (Store.getMode()) {
    case 'DRAW':
    case 'DRAWRECT':
    case 'DRAWELLIPSE':
    case 'RULER':
    case 'DRAWARROW':
      Dispatcher.dispatch({
        type: 'ACTIVITY_UPDATE',
        inProgress: false,
      });
      break;

    default:
      break;
  }
}